import account from "./account";
import certificate from "./certificate";
import staging from "./staging";
import release from "./release";
import businessRules from "@/api/businessRules";
import superDeviceTemplate from "@/api/superDeviceTemplate";
import aiModel from "./aiModel";
import devicePlugin from "./devicePlugin";
import solution from "./solution";
import productManage from "./productManage";
import auth from "./auth";

type AccountType = typeof account;
type CertificateType = typeof certificate;
type StagingType = typeof staging;
type ReleaseType = typeof release;
type AiModelType = typeof aiModel;
type DevicePluginType = typeof devicePlugin;
type SolutionType = typeof solution;
type ProductManage = typeof productManage;
type Auth = typeof auth;

interface IAny {
  [key: string]: any
}


type ApiType = IAny & AccountType & CertificateType & StagingType & ReleaseType & AiModelType & DevicePluginType & SolutionType & ProductManage & Auth; 

const api: ApiType = {
  ...account,
  ...certificate,
  ...staging,
  ...release,
  ...aiModel,
  ...devicePlugin,
  ...solution,
  ...productManage,
  ...auth,
  ...businessRules,
  ...superDeviceTemplate
};

export default api;
